import { Cache } from "~/types/cache";
export const useClaimStore = defineStore(
  Cache.CLAIM,
  () => {
    // 模型申领状态
    const claimType = ref("");
    const setClaimType = (type: string) => (claimType.value = type);
    // 原始模型id
    const originModelId = ref("");
    const setOriginModelId = (id: string) => (originModelId.value = id);
    // 主页链接
    const homepageUrl = ref("");
    const setHomepageUrl = (url: string) => (homepageUrl.value = url);
    // 模型名称
    const modelName = ref("");
    const setModelName = (name: string) => (modelName.value = name);
    // 是否验证
    const verified = ref(false);
    const setVerified = (flag: boolean) => (verified.value = flag);
    // 模型认领id
    const linkId = ref("");
    const setLinkId = (id: string) => (linkId.value = id);
    // 更多模型按钮显示
    const resultVisible = ref(false);
    const setResultVisible = (flag: boolean) => (resultVisible.value = flag);
    // 成功认领的模型个数
    const resultSuccessNum = ref(0);
    const setResultSuccessNum = (num: number) => (resultSuccessNum.value = num);
    // 失败模型的个数
    const resultFailNum = ref(0);
    const setResultFailNum = (num: number) => (resultFailNum.value = num);
    // 认领获取的积分
    const resultIntegral = ref(0);
    const setResultIntegral = (num: number) => (resultIntegral.value = num);
    // 结果类型
    const resultType = ref("");
    const setResultType = (type: string) => (resultType.value = type);
    return {
      claimType,
      setClaimType,
      homepageUrl,
      setHomepageUrl,
      modelName,
      setModelName,
      verified,
      setVerified,
      linkId,
      setLinkId,
      resultVisible,
      setResultVisible,
      resultSuccessNum,
      setResultSuccessNum,
      resultFailNum,
      setResultFailNum,
      resultIntegral,
      setResultIntegral,
      resultType,
      setResultType,
      originModelId,
      setOriginModelId,
    };
  },
  {
    persist: {
      storage: persistedState.localStorage,
    },
  }
);
